import React from "react";
import styled from "@emotion/styled";

import showoff1 from "../../../images/battlerush-showoff/showoff-1.png";
import showoff2 from "../../../images/battlerush-showoff/showoff-2.png";
import { SMALL_DEVICES } from "../../../mediaQueries";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: fit-content;
  min-height: 120vh;

  ${SMALL_DEVICES} {
    min-height: 100vw;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const Image = styled.img`
  object-fit: contain;
  max-height: 1000px;
  width: 40vw;
`;

const ShowoffText = styled.div`
  font-size: 4vw;
  color: white;
  font-weight: lighter;
`;

export const ShowoffSection = () => {
  return (
    <Container>
      <ImageContainer>
        <Image src={showoff1} />
        <Image src={showoff2} />
      </ImageContainer>

      <ShowoffText>Creating beautiful and fun experiences</ShowoffText>
    </Container>
  );
};
